import { Can } from "@/casl-provider";
import { CustomerSapExportTable } from "@/components/data-table/predefined/customer-sap-export-table/customer-sap-export-table";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";

export function CustomerSapExportView() {
  const { t } = useTranslation(["common", "aceSapExportIssues"]);

  return (
    <Can I="read" a="CustomerSapExport">
      <CenteredLayout
        variant={CenteredLayoutVariant.Table}
        title={t("aceSapExportIssues:SapExports")}
        subTitle={t("common:SearchFilterAndManageEntriesDescription")}
      >
        <CustomerSapExportTable />
      </CenteredLayout>
    </Can>
  );
}
